import { useEffect } from 'react'
import { SVG } from '../SVG'

export const CheckAnimationIcon = ({ style = {}, ...props }) => {
  useEffect(() => {
    const styleTag = document.createElement('style')
    styleTag.innerHTML = `
      .checkmark {
        border-radius: 50%;
        display: block;
        stroke-width: 2;
        stroke-miterlimit: 10;
        box-shadow: inset 0px 0px 0px var(--color-white);
        animation: fill 0.4s ease-in-out 0.4s forwards, scale 0.3s ease-in-out 0.9s both;
        position: relative;
      }
      .checkmark__circle {
        stroke-dasharray: 166;
        stroke-dashoffset: 166;
        stroke-width: 2;
        stroke-miterlimit: 10;
        stroke: var(--color-white);
        animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
      }
      .checkmark__check {
        transform-origin: 50% 50%;
        stroke-dasharray: 48;
        stroke-dashoffset: 48;
        stroke-width: 4;
        animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
        stroke: var(--success-color);
      }
      .checkmark__ring {
        stroke-dasharray: 166;
        stroke-dashoffset: 166;
        stroke-width: 4;
        stroke: var(--success-color);
        fill: none;
        transform-origin: center;
        animation: ringStroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
      }
      @keyframes stroke {
        100% { stroke-dashoffset: 0; }
      }
      @keyframes ringStroke {
        100% { stroke-dashoffset: 0; }
      }
      @keyframes scale {
        0%, 100% { transform: none; }
        50% { transform: scale3d(1.2, 1.2, 1); }
      }
      @keyframes fill {
        100% { box-shadow: inset 0px 0px 0px 30px var(--color-white); }
      }
    `
    document.head.appendChild(styleTag)
    return () => document.head.removeChild(styleTag)
  }, [])

  return (
    <SVG
      viewBox='0 0 52 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='checkmark'
      style={{ stroke: 'var(--color-white)', ...style }}
      {...props}
    >
      <circle className='checkmark__ring' cx='26' cy='26' r='23' />
      <circle className='checkmark__circle' cx='26' cy='26' r='25' fill='none' />
      <path className='checkmark__check' fill='none' d='M14.1 27.2l7.1 7.2 16.7-16.8' />
    </SVG>
  )
}
